<script setup>
    const props = defineProps({
        data: {
            type: [Object,Array],
            default: {}
        }
    })
    
</script>

<template>
        <div class="line" :style="{ paddingTop: props.data.margin_vertical + 'px', paddingBottom: props.data.margin_vertical + 'px', marginLeft: props.data.margin_horizontal + 'px', marginRight: props.data.margin_horizontal + 'px' }">
            <div :style="{ borderTopWidth: '1px', borderTopStyle: props.data.style, borderTopColor: props.data.fill_color }"></div>
        </div>
</template>

<style lang="scss" scoped>
.line {

}
</style>